import { BaseController } from '../../common/base/controller';

export class NotFoundController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({ controllerService });
  }

  $onInit() {
    this.brandLogo = this.config.ui.navbar.brandLogo;
  }
}
